import { apiFetch } from "../utils/apiFetch"
import { User } from "../slices/authSlice"

export interface AdminUser {
  _id: string
  firstName: string
  lastName: string
  email: string
  company?: string
  isAdmin: boolean
  canReleaseFilings?: boolean
  twoFactorEnabled?: boolean
  verified: boolean
  active: boolean
  createdAt: string
}

export interface AdminUsersResponse {
  users: AdminUser[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export async function getAdminUsers(page = 1, limit = 20, search = ""): Promise<AdminUsersResponse> {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : ""
  return apiFetch(`/api/admin/users?page=${page}&limit=${limit}${searchParam}`)
}

export async function updateUserStatus(id: string, active: boolean): Promise<{ user: { id: string; active: boolean } }> {
  return apiFetch(`/api/admin/users/${id}/status`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ active })
  })
}

export async function updateUserRole(id: string, isAdmin: boolean): Promise<{ user: { id: string; isAdmin: boolean } }> {
  return apiFetch(`/api/admin/users/${id}/role`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ isAdmin })
  })
}

export async function updateUserFilingApproval(id: string, canReleaseFilings: boolean): Promise<{ user: { id: string; canReleaseFilings: boolean } }> {
  return apiFetch(`/api/admin/users/${id}/filing-approval`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ canReleaseFilings })
  })
}

export async function resetUserTwoFactor(id: string): Promise<{ user: { id: string; twoFactorEnabled: boolean } }> {
  return apiFetch(`/api/admin/users/${id}/two-factor`, { method: "DELETE" })
}

export type ProfileUpdate = Partial<Omit<User, "id" | "isAdmin">>

export async function updateMe(data: ProfileUpdate): Promise<{ user: User }> {
  return apiFetch("/api/users/me", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export async function updatePassword(data: {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}): Promise<{ message: string }> {
  return apiFetch("/api/users/me/password", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}
